<template>
  <div class="user_works">
    <div class="user_works_head" :class="scrollTopClass ? 'scrool' : ''">
      <van-icon name="arrow-left" @click="onClickLeft" />
      <div class="title">{{ $t('message.user.mywork') }}</div>
    </div>
    <div class="user_works_list">
      <div class="user_works_list_user">
        <div class="user_works_list_user_img">
          <img :src="userInfo.headImgUrl" alt="" v-if="userInfo.headImgUrl" />
          <img src="../../../../static/image/user_img.png" alt="" v-else />
        </div>
        <div class="user_works_list_user_name">{{ userInfo.nickName }}</div>
      </div>
      <div class="user_works_list_head">
        <div
          class="user_works_list_head_li"
          v-for="(item, index) in navTabList"
          :key="index"
          @click="navIndexClick(item.id)"
          :class="navIndex == item.id ? 'active' : ''"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="data_list">
        <van-list
          v-model="loading"
          :finished="finished"
          offset="150"
          @load="onLoad()"
          style="width: 100%"
        >
          <div class="van-clearfix">
            <div
              v-for="(item, index) in dataList"
              :key="index"
              class="data_list_li"
              @click="detailsClick(item)"
            >
              <div class="abpos" v-if="item.workList">
                <i class="icon-jr-icon-one iconfont"></i>
                <span>{{ item.workList.length }}</span>
              </div>
              <img v-if="item.workList" :src="item.workList[0].workPath" alt="" />
              <img v-else-if="item.workVideoList" :src="item.workVideoList[0]" alt="" />
              <img v-else-if="item.workTiffList" :src="item.workTiffList[0]" alt="" />
              <!-- <video :src="item."></video> -->
              <img v-else src="../../../../static/image/moren.png" alt="" />
              <div>
                <div class="data_list_li_title">
                  <p v-if="item.workTitle">{{ item.workTitle }}</p>
                </div>
                <div class="data_list_li_p">
                  <p v-if="item.votes">
                    <i class="icon-jr-icon-data iconfont"></i>{{ item.votes
                    }}{{ $t('message.user.ticket') }}
                  </p>
                  <p v-else>
                    <i class="icon-jr-icon-data iconfont"></i>0{{ $t('message.user.ticket') }}
                  </p>
                  <!-- <span>投票</span> -->
                </div>
              </div>
              <div class="workStatus color1" v-if="item.workStatus == 4">审核通过</div>
              <div class="workStatus color2" v-else-if="item.workStatus == 5">审核不通过</div>
              <div class="workStatus color3" v-else>审核中</div>
            </div>
          </div>
        </van-list>
      </div>
    </div>
  </div>
</template>

<script>
import { apiUser, userWorksAll } from '@/api/user.js'
import { Toast } from 'vant'
export default {
  name: 'UserWorks',
  data() {
    return {
      scrollTopClass: false,
      loading: false,
      finished: false,
      pageindex: 0,
      userInfo: {},
      navIndex: 3,
      dataList: [],
      navTabList: [
        {
          name: this.$t('message.explain.photo'), // 摄影
          id: 3
        },
        {
          name: this.$t('message.explain.voide'), // 视频
          id: 2
        },
        {
          name: this.$t('message.explain.pain'), // 绘画
          id: 4
        },
        // // 动漫
        // {
        //   name: this.$t('message.explain.animation'),
        //   id: 5
        // },
        {
          name: this.$t('message.explain.sci_work'), // 科创
          id: 6
        }
        // {
        //   name: '音乐',
        //   id: 7
        // }
      ]
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll, true)
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  created() {
    if (sessionStorage.getItem('navIndex')) {
      this.navIndex = sessionStorage.getItem('navIndex')
    }
    // console.log(this.navIndex)
    this.getUser()
    // this.onLoad()
  },
  methods: {
    detailsClick(row) {
      // console.log(this.navIndex);
      // console.log(row.workStatus)
      sessionStorage.setItem('navIndex', this.navIndex)
      if (row.workStatus == 5) {
        return Toast('审核未通过，暂不能查看！')
      } else if (row.workStatus != 4 && row.workStatus != 5) {
        return Toast('作品正在审核中，暂不支持查看')
      }
      this.$router.push({
        name: 'worksDetails',
        query: { id: row.id, conditionsOfVoting: '2' }
      })
    },
    handleScroll(e) {
      // 元素滚动高度
      if (e.target.scrollTop > 10) {
        this.scrollTopClass = true
      } else {
        this.scrollTopClass = false
      }
    },

    navIndexClick(id) {
      if (this.loading) {
        return
      }
      this.navIndex = id
      this.dataList = []
      this.pageindex = 1
      this.onLoad()
    },
    async onLoad() {
      this.loading = true
      const queryInfo = {
        pageNum: this.pageindex,
        pageSize: 20,
        workType: this.navIndex
      }
      const { data: res } = await userWorksAll(queryInfo)
      if (res.resultCode === 200) {
        this.dataList = [...this.dataList, ...res.data.list]
        this.total = res.data.pages
        this.loading = false
        if (res.data.hasNextPage) {
          this.pageindex++
          // this.onLoad()
        } else {
          this.finished = true
        }
      } else {
        this.finished = true
        this.loading = false
        this.title = '暂无数据'
      }
    },
    async getUser() {
      const { data: res } = await apiUser()
      if (res.resultCode === 200) {
        this.userInfo = res.data
      }
    },
    onClickLeft() {
      sessionStorage.removeItem('navIndex')
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="less" scoped>
.user_works {
  width: 100%;
  overflow: hidden;
  background-image: url('../../../../static/image/myworks.png');
  background-repeat: no-repeat;
  background-size: 100vw auto;

  /deep/.van-list__finished-text {
    width: 100%;
    float: left;
  }

  .data_list_li_title {
    width: 100%;
    p {
      color: #3c3b3f;
      font-size: 0.2667rem;
      white-space: nowrap;
      text-overflow: ellipsis;
      padding: 0 0.32rem;
      font-weight: 500;
      margin: 0.2667rem 0 0.16rem 0;
      overflow: hidden;
    }
  }

  .scrool {
    width: 100%;
    background: linear-gradient(301.69deg, #6688ff 13.72%, #3360ff 67.35%);
    box-shadow: 0px 0px 12px rgb(255 192 21 / 20%);
    z-index: 9;
  }

  .user_works_head {
    width: 100%;
    overflow: hidden;
    display: flex;
    height: 46px;
    line-height: 46px;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    left: 0;

    i {
      position: absolute;
      top: 15px;
      color: #fff;
      left: 15px;
    }

    div {
      color: #fff;
      font-size: 16px;
      font-weight: 500;
    }
  }

  .user_works_list {
    width: 100%;
    box-sizing: border-box;
    padding: 0 16px;
    border-radius: 30px 30px 0 0;
    background-color: #fff;
    margin-top: 180px;

    .user_works_list_user {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 100%;
      img {
        width: 64px;
        height: 64px;
        border-radius: 50%;
        margin-top: -32px;
      }

      .user_works_list_user_name {
        width: 100%;
        overflow: hidden;
        text-align: center;
        color: #263245;
        font-size: 16px;
        font-weight: 500;
        margin: 12px 0;
      }
    }

    .user_works_list_head {
      width: 100%;
      overflow-x: scroll;
      overflow-y: hidden;
      height: 30px;
      display: flex;

      .user_works_list_head_li {
        // width: 55px;
        height: 20px;
        flex: none;
        line-height: 20px;
        margin: 5px 14px 5px 0;
        border-radius: 2px;
        background: #d3d3d3;
        color: #8f8f8f;
        font-size: 12px;
        font-weight: 400;
        text-align: center;
        float: left;
        padding: 0 10px;
      }

      .active {
        background: #3562ff;
        border-radius: 4px;
        color: #fff;
        margin: 1px 14px 1px 0;
        height: 28px;
        line-height: 28px;
        font-weight: 500;
        font-size: 14px;
        padding: 0 10px;
      }
    }
    .user_works_list_head::-webkit-scrollbar {
      display: none;
    }

    .data_list {
      width: 100%;
      box-sizing: border-box;
      overflow: hidden;
      background: #e5e5e5;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: flex-start;
      box-sizing: border-box;
      padding: 0.5333rem 0.4267rem;
      margin: 0.5333rem 0 2.1333rem 0;

      .data_list_li {
        float: left;
        // width: 49%;
        width: 4rem;
        margin-bottom: 0.32rem;
        border-radius: 0.1067rem;
        flex-direction: column;
        border-radius: 0.1067rem;
        // display: flex;
        position: relative;
        background-color: #fff;

        .workStatus {
          position: absolute;
          top: 7px;
          right: 6px;
          font-size: 14px;
          color: #fff;
          font-weight: 400;
          text-align: center;
          line-height: 20px;
          border-radius: 4px;
          padding: 2px 5px;
        }
        .color1 {
          color: #1eba11;
          background-color: rgba(37, 229, 21, 0.2);
        }
        .color2 {
          color: #f64720;
          background-color: rgba(246, 71, 32, 0.2);
        }
        .color3 {
          color: #f6a020;
          background-color: rgba(246, 160, 32, 0.2);
        }

        .abpos {
          position: absolute;
          right: 5px;
          // top: 5px;
          bottom: 5px;
          width: 32px;
          display: flex;
          z-index: 3;
          align-items: center;
          justify-content: center;
          height: 20px;
          background: rgba(177, 177, 177, 0.3);
          border-radius: 4px;

          i {
            color: #fff;
            font-size: 12px;
          }

          span {
            color: #fff;
            font-size: 10px;
            font-weight: 500;
          }
        }

        img {
          // width: 4rem;
          // height: auto;
          object-fit: contain;
          width: 4rem;
          height: 84px;
          display: block;
          border-radius: 0.1067rem 0.1067rem 0 0;
        }

        .data_list_li_p {
          width: 100%;
          height: 0.8533rem;
          display: flex;
          justify-content: space-between;
          align-items: center;
          box-sizing: border-box;
          padding: 0 0.32rem;

          p {
            margin: 0;
            color: #1a1a1a;
            font-size: 0.2667rem;
            font-weight: 300;
          }

          i {
            color: #8f8f8f;
            font-size: 0.32rem;
            margin-right: 0.08rem;
          }
        }

        span {
          color: #3562ff;
          font-size: 0.2933rem;
          font-weight: 400;
        }
      }

      .data_list_li:nth-child(2n + 0) {
        float: right;
      }
    }
  }
}
</style>
